<template>
    <div class="row">
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="member-id"> Member ID <span class="text-danger">*</span> </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="member-id"
                    type="text"
                    placeholder="Enter Member ID"
                    v-model="payer.MemberId"
                    @blur="v$.payer.MemberId.$touch"
                    :class="`${!v$.payer.MemberId.$error ? '' : 'field-invalid'}`"
                />
                <span v-if="v$.payer.MemberId.$error" class="field-invalid">Member Id is required.</span>
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="group-name"> Group Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-name"
                    type="text"
                    placeholder="Enter Group Name"
                    v-model="payer.GroupName"
                />
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="group-id"> Group ID </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-id"
                    type="text"
                    placeholder="Enter Group ID"
                    v-model="payer.GroupId"
                />
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="relationship-to-insured">
                    Relationship to Insured
                    <span class="text-danger">*</span>
                </label>
                <select
                    class="form-select"
                    name="relationship-to-insured"
                    v-model="payer.RelationshipToInsured"
                    @blur="v$.payer.RelationshipToInsured.$touch"
                    :class="`${!v$.payer.RelationshipToInsured.$error ? '' : 'field-invalid'}`"
                >
                    <option :value="null">Select Relationship to Insured</option>
                    <option
                        v-for="[key, value] of enumToMap(relationshipToInsuredEnum)"
                        :key="key"
                        :value="value.value"
                    >
                        {{ value.name }}
                    </option>
                </select>
                <span v-if="v$.payer.RelationshipToInsured.$error" class="field-invalid"
                    >Relationship is required.</span
                >
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="group-id"> Case Manager </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-id"
                    type="text"
                    placeholder="Enter Case Manager"
                    v-model="payer.CaseManager"
                />
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="employer-name"> Employer Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="employer-name"
                    type="text"
                    placeholder="Enter Employer Name"
                    v-model="payer.EmployerName"
                />
            </div>
        </div>
        <template v-if="showSubscriberName">
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="subs-first-name"> Subscriber First Name <span class="text-danger">*</span> </label>
                    <input
                        class="form-control"
                        name="subs-first-name"
                        type="text"
                        placeholder="Enter Subscriber First Name"
                        v-model="payer.SubscriberFirstName"
                        @blur="v$.payer.SubscriberFirstName.$touch"
                        :class="`${!v$.payer.SubscriberFirstName.$error ? '' : 'field-invalid'}`"
                    />
                    <span v-if="v$.payer.SubscriberFirstName.$error" class="field-invalid"
                        >Subscriber First Name is required.</span
                    >
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="subs-last-name"> Subscriber Last Name <span class="text-danger">*</span> </label>
                    <input
                        class="form-control"
                        name="subs-last-name"
                        type="text"
                        placeholder="Enter Subscriber Last Name"
                        v-model="payer.SubscriberLastName"
                        @blur="v$.payer.SubscriberLastName.$touch"
                        :class="`${!v$.payer.SubscriberLastName.$error ? '' : 'field-invalid'}`"
                    />
                    <span v-if="v$.payer.SubscriberLastName.$error" class="field-invalid"
                        >Subscriber Last Name is required.</span
                    >
                </div>
            </div>
        </template>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="deductible-amount"> Deductible Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="deductible-amount"
                    type="text"
                    placeholder="Enter Deductible Amount"
                    v-model="payer.DeductibleAmount"
                    v-number-only
                />
            </div>
            <div class="form-group">
                <label for="out-of-pocket-amount"> Out-of-Pocket Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="out-of-pocket-amount"
                    type="text"
                    placeholder="Enter Out-of-Pocket Amount"
                    v-model="payer.OutOfPocketMaxAmount"
                />
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group d-flex flex-row justify-content-between">
                <div>
                    <label for="has-deductible-met" class="me-2"> Deductible Met </label>
                    <div>
                        <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                            <label
                                :class="`btn btn-outline-secondary ${payer.DeductibleMet ? 'active' : ''}`"
                                @click="hasDeductibleMetChanged(true)"
                            >
                                <input type="radio" hidden name="has-deductible-met" autocomplete="off" /> Yes
                            </label>
                            <label
                                :class="`btn btn-outline-secondary ${payer.DeductibleMet ? '' : 'active'}`"
                                @click="hasDeductibleMetChanged(false)"
                            >
                                <input type="radio" hidden name="has-deductible-met" autocomplete="off" /> No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="out-of-pocket-met"> Out-of-Pocket Met </label>
                <div>
                    <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                        <label
                            :class="`btn btn-outline-secondary ${payer.IsOutOfPocketMaxMet ? 'active' : ''}`"
                            @click="outOfPocketMaxMetChanged(true)"
                        >
                            <input type="radio" name="out-of-pocket-met" autocomplete="off" hidden /> Yes
                        </label>
                        <label
                            :class="`btn btn-outline-secondary ${payer.IsOutOfPocketMaxMet ? '' : 'active'}`"
                            @click="outOfPocketMaxMetChanged(false)"
                        >
                            <input type="radio" name="out-of-pocket-met" autocomplete="off" hidden /> No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="copay-amount"> Copay Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="copay-amount"
                    type="text"
                    placeholder="Enter Copay Amount"
                    v-model="payer.CopayAmount"
                />
            </div>
            <div class="form-group">
                <label for="coinsurance">Coinsurance Amount</label>
                <div class="d-flex flex-row">
                    <div class="form-check custom-radio">
                        <input
                            type="radio"
                            id="dollar-amount"
                            name="coinsurance"
                            class="form-check-input"
                            :value="false"
                        />
                        <label class="form-check-label" for="dollar-amount">
                            <span class="me-1">Dollar Amount</span>
                        </label>
                    </div>
                    <div class="form-check custom-radio ps-4 ms-4">
                        <input type="radio" id="percentage" name="coinsurance" class="form-check-input" :value="true" />
                        <label class="form-check-label" for="percentage">
                            <span class="me-1">Percentage</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="coinsurance-amount"> Coinsurance Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="coinsurance-amount"
                    type="text"
                    placeholder="Enter Coinsurance Amount"
                    v-model="payer.CoinsuranceAmount"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";

import { enumToMap } from "../../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { PatientPayor } from "../../../../../../../resources-vue/vue-models/patient-payor";

export default defineComponent({
    props: {
        payer: {
            type: Object
        },
        relationshipToInsuredEnum: {
            default: null
        },
        payerSequenceCodeEnum: {
            default: null
        },
        hasDeductibleMetChanged: {
            type: Function
        },
        showSubscriberName: {
            type: Boolean
        },
        roomAndBoardTypeValue: {
            type: Number
        },
        palliativeCareTypeValue: {
            type: Number
        },
        requireAuthorizationChanged: {
            type: Function
        },
        outOfPocketMaxMetChanged: {
            type: Function
        }
    },
    data() {
        return {
            enumToMap,
            v$: useVuelidate()
        };
    },

    validations() {
        return {
            payer: {
                MemberId: { required },
                RelationshipToInsured: { required },
                SubscriberFirstName: {
                    required: requiredIf(() => {
                        return this.showSubscriberName;
                    })
                },
                SubscriberLastName: {
                    required: requiredIf(() => {
                        return this.showSubscriberName;
                    })
                }
            }
        };
    }
});
</script>
